// extracted by mini-css-extract-plugin
export default {"panel":"TopPanel_panel__iLQG6","panel-title":"TopPanel_panel-title__GgEgW","panel-content":"TopPanel_panel-content__GJd3O","loading-value":"TopPanel_loading-value__OeDS8"};